import { useCallback, useEffect, useState } from "react";
import { getUsersWithLiveTrainingInfo } from 'api/services/lesson-service';
import useWorkspaceApiCall from "hooks/useWorkspaceApiCall";
import { LiveTrainingData } from "models/LiveTrainingData";

export const useLiveTrainingInfo = (userIds: string[], lessonIds: string[]) => {
    const [liveTrainingData, setLiveTrainingData] = useState<LiveTrainingData[]>([]);
    const { callAPI: fetchLiveTrainingInfo, loading,  } = useWorkspaceApiCall(getUsersWithLiveTrainingInfo, '', 'getUsersWithLiveTrainingInfo.error');

    const getLiveTrainingInfo = useCallback(async (userIds: string[], lessonIds: string[]) => {
        const response = await fetchLiveTrainingInfo({ userIds, lessonIds })
        if (response?.success && response.data) {
            setLiveTrainingData(response.data);
        }
    }, [fetchLiveTrainingInfo]);

    useEffect(() => {
        if (userIds.length > 0 && lessonIds.length > 0) {
            getLiveTrainingInfo(userIds, lessonIds);

            const intervalId = setInterval(() => {
                getLiveTrainingInfo(userIds, lessonIds);
            }, 5000);

            return () => clearInterval(intervalId);
        }
    }, [getLiveTrainingInfo, userIds, lessonIds]);
    

    return { liveTrainingData, loading };
};